import {ContentContainer} from '@coolcolduk/ui-mui';
import {PrivateRouteProps} from '../../config/routeType';
import FlashCard from './FlashCard';

export default function FlashCardPage({user: _u}: PrivateRouteProps) {
  return (
    <ContentContainer data-testid="flashcard-page">
      <FlashCard />
    </ContentContainer>
  );
}
